import React from 'react';
import { MOTIVO_WARNING_TEXT } from '../config/workspaceMotivos';

type IconProps = {
  title?: string;
  className?: string;
};

export const RecuperacaoMotivoWarningIcon: React.FC<IconProps> = ({
  title = 'Classificação de motivo em falta',
  className = '',
}) => (
  <span
    className={`rec-motivo-warn-icon ${className}`.trim()}
    role="img"
    aria-label={title}
    title={title}
  >
    ⚠
  </span>
);

type BannerProps = {
  className?: string;
  message?: string;
};

export const RecuperacaoMotivoWarningBanner: React.FC<BannerProps> = ({
  className = '',
  message = MOTIVO_WARNING_TEXT,
}) => (
  <div className={`rec-motivo-warn-banner ${className}`.trim()} role="alert">
    <RecuperacaoMotivoWarningIcon title={message} />
    <p>{message}</p>
  </div>
);

export default RecuperacaoMotivoWarningBanner;
